import { render, staticRenderFns } from "./NotificacioncontactoModals.vue?vue&type=template&id=73c9ae51"
import script from "./NotificacioncontactoModals.vue?vue&type=script&lang=js"
export * from "./NotificacioncontactoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports